<template>
  <button type="button"
          class="inline-flex border-2 border-transparent rounded-full bg-dark-foreground h-[38px] w-[74px]"
          @click="toggle">
    <span class="shadow-lg h-[34px] w-[34px] inline-block rounded-full shadow-lg transition duration-300"
          :class="active ? 'translate-x-0 bg-accent' : '-translate-x-9 bg-white'"></span>
  </button>
</template>

<script>
export default {
  name: "VSwitch",
  props: {
    value: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    return {
      active: this.value
    }
  },
  methods: {
    toggle() {
      this.active =  this.active === 1 ? 0 : 1
      this.$emit('update:modelValue', this.active)
    }
  }
}
</script>

<style scoped>

</style>